/**
 * Google Analytics event names.
 */
export enum EWebEvents {
  PLAY = 'web_video_play',
  COMPLETE = 'web_video_complete',
  LOAD_COMPLETE = 'web_video_load_complete',
  PAUSE = 'web_video_pause',
  SEEK = 'web_video_seek',
  REPLAY = 'web_video_replay',
  END = 'web_video_end',
  NETWORK_CHANGE = 'web_network_change',
  MUTE = 'web_video_mute',
  UNMUTE = 'web_video_unmute',
  PROGRESS = 'web_video_progress',
  PREVIEW_START = 'web_video_preview_start',
  PREVIEW_END = 'web_video_preview_end',
}
